import { HttpClient } from '@wix/sdk-types';
import {
  ListTippableStaffOptions,
  ListTippableStaffResponse,
  ListTippableStaffResponseNonNullableFields,
  listTippableStaff as universalListTippableStaff,
} from './tips-staff-v1-staff-tippable-staff.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function listTippableStaff(
  httpClient: HttpClient
): ListTippableStaffSignature {
  return (options?: ListTippableStaffOptions) =>
    universalListTippableStaff(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListTippableStaffSignature {
  /**
   * Retrieves a list of up to 100 staff who are eligible to receive tips, given
   * the provided filtering.
   * @param - Options to use when listing tippable staff.
   */
  (options?: ListTippableStaffOptions | undefined): Promise<
    ListTippableStaffResponse & ListTippableStaffResponseNonNullableFields
  >;
}

export {
  IdentificationData,
  IdentificationDataIdOneOf,
  IdentityType,
  ListTippableStaffOptions,
  ListTippableStaffRequest,
  ListTippableStaffResponse,
  ListTippableStaffResponseNonNullableFields,
  Staff,
} from './tips-staff-v1-staff-tippable-staff.universal.js';
